module.exports = __webpack_public_path__ + "static/logo-vector-708d9391f2faf351a7309f5fb19b6651.svg";